import React from "react";
import HeaderAyuda from "../../ComponentsNav/Header/HeaderAyuda";
import FooterAyuda from "../../ComponentsNav/Footer/FooterAyuda";
import "./ayuda.css";
import { withRouter } from "react-router";

class AyudaSalesforce extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cargando: false, opciones: [] };
  }

  componentDidMount() {
    let self = this;
    self.setState({ cargando: true });
    fetch(process.env.REACT_APP_JSON_OPCIONES)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        self.setState({ cargando: false, opciones: JSON.parse(data) });
      })
      .catch(function (err) {
        console.error(err);
        self.setState({ cargando: false });
      });
  }

  cambiaPantalla(url) {
    this.props.history.push(url);
  }

  render() {
    return (
      <div className={"container__font--" + this.props.marca}>
        <HeaderAyuda marca={this.props.marca}></HeaderAyuda>
        <div className="container-fluid form__container--sup">
          <div className="container">
            <div
              className={
                "form__container form__container--ayuda container--" +
                this.props.marca
              }
            >
              <div className="form col-12">
                <div className="tabla_contenido row">
                  <div className="col-12">
                    <h3 className="font-titulo_tabla text-center font-weight-bold mt-3 mb-3">
                      Materiales
                    </h3>
                  </div>
                  <div className="col-12 pb-5">
                    {this.state.opciones.length > 0 && (
                      <div className="row">
                        {this.state.opciones.map((opcion, i) => {
                          return (
                            <React.Fragment key={"opcion-" + i}>
                              {opcion.titulo === "Inicio" ? (
                                ""
                              ) : (
                                <div
                                  key={"opcion-" + i}
                                  className="col-10 offset-1 offset-md-0 col-md-4 text-center"
                                >
                                  <div
                                    className="form__container--ayuda-tarjeta pt-3 pb-3"
                                    onClick={() => {
                                      this.cambiaPantalla(opcion.url);
                                    }}
                                  >
                                    <h4 className="font-weight-bold">
                                      {opcion.titulo}
                                    </h4>
                                  </div>
                                  <p className="form__container--ayuda-texto-titulo pt-2 pb-2">{opcion.tituloTexto}</p>
                                </div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form__container--ayuda-actualizacion">
                Última actualización: 27/07/2021
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            "page__cargando" + (this.state.cargando ? " d-block" : " d-none")
          }
        ></div>
        <FooterAyuda marca={this.props.marca}></FooterAyuda>
      </div>
    );
  }
}

export default withRouter(AyudaSalesforce);
